import React, { Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from '../../assets/images/arrow-left.svg';
import { PanelImageSetting } from './form-settings/panel-image-setting';
import Switch from '../../components/common/switch';
import InputElement from '../../components/FormElements/input';
import { ReactComponent as CopyIcon } from '../../assets/images/copy.svg';
import uuid from 'react-uuid';

import styled from 'styled-components';

export const PanelConfig = ({ panel, setShowEditPage, panelConfig, setPanelConfig, panelWidgets, selectWidget }) => {
  const { t } = useTranslation();

  const getPanelWidgetList = panel => {
    return panelWidgets.find(p => (panel?.key ? panel?.key === p.id : panel?.id === p.id))?.widgets || [];
  };

  const copyPanel = panel => {
    const id = uuid();
    const copy = {
      ...panel,
      id: id,
      key: id,
      isNew: true,
      priority: panel?.priority,
    };
    const widgets = panelWidgets.find(p => p.id === panel.id)?.widgets;
    const pwidgets = widgets.map(w => ({
      ...w,
      id: null,
      components: w.components.map(c => ({ ...c, id: null, columns: c.columns?.map(col => ({ ...col, id: null })) })),
    }));

    navigator.clipboard.writeText(JSON.stringify({ panel: copy, widgets: pwidgets }));
  };

  return (
    <PanelConfigWrapper className="flex-column flex-1 overflow-hidden">
      <div className="flex items-center">
        <div className="flex items-center pxy-1 mr-2 cursor" onClick={() => setShowEditPage(false)}>
          <ArrowLeftIcon height={16} width={16} />
        </div>
        <div className="flex-1 flex items-center">
          <label className="medium-text font-16">{panel?.name}</label>
          <div className="flex ml-6 cursor">
            <CopyIcon
              height={20}
              width={20}
              onClick={e => {
                e.stopPropagation();
                copyPanel(panel);
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex-column overflow-scroll px-1" style={{ height: 'calc(100vh - 120px)' }}>
        <div className="flex-column my-8">
          <label className=" flex-1 medium-text font-16">{t('OPTIONS_UC')}</label>
          <div className="mt-6">
            <PanelImageSetting
              key={panel?.id}
              panel={panel}
              panelConfig={panelConfig}
              setPanelConfig={setPanelConfig}
            />
          </div>
          <div className="flex mt-6">
            <label className="regular-text flex-1">{t('REPEATING')}</label>
            <Switch
              enabled={panel?.is_repeating}
              onClick={() =>
                setPanelConfig(
                  panelConfig.map(pc => (pc.id === panel?.id ? { ...pc, is_repeating: !panel?.is_repeating } : pc)),
                )
              }
            />
          </div>
          <InputElement
            name="Lexicon"
            onChange={value =>
              setPanelConfig(panelConfig.map(pc => (pc.id === panel?.id ? { ...pc, base_lexicon: value } : pc)))
            }
            value={panel?.base_lexicon}
            label="Enter"
            className="w-full mt-6"
            font={{ size: 12 }}
          />
          <InputElement
            name="Conditional lexicon"
            onChange={value =>
              setPanelConfig(panelConfig.map(pc => (pc.id === panel?.id ? { ...pc, conditional_lexicon: value } : pc)))
            }
            value={panel?.conditional_lexicon}
            label="Enter"
            className="w-full mt-6"
            font={{ size: 12 }}
          />
        </div>
        <div className="flex-column pt-6 border-top">
          <label className="flex medium-text  mb-6">{t('WIDGETS_UC')}</label>
          {getPanelWidgetList(panel).map(widget => (
            <div
              className="flex items-center px-4 py-2 radius-4 mb-4 cursor widget-component-container"
              onClick={() => {
                selectWidget(widget);
              }}>
              <label className="regular-text font-16 flex-1 one-line">{widget.name}</label>
            </div>
          ))}
        </div>
      </div>
    </PanelConfigWrapper>
  );
};

const PanelConfigWrapper = styled('div')`
  .input-element {
    height: 40px !important;
    border-radius: 16px;
  }
`;
